import { Select } from '@mantine/core';
import { useMyRoles } from '../api/hooks/useVisitors.ts';

/**
 * Drives the `role=` query param on visitor/group list endpoints. Reads the
 * caller's Role-entity memberships from /api/roles/currentUser.
 *
 * For privileged callers (ROLE_GOVERNMENT_FORM, ROLE_GLOBAL_TRAVEL) the
 * backend would accept `role=0` for "show all"; we leave that bypass out of
 * the dropdown for now — the legacy frontend gates it behind a separate
 * "see all" toggle that we can add later.
 */
export function RoleSelector({
  value,
  onChange,
}: {
  value: number | null;
  onChange: (v: number) => void;
}) {
  const { data, isPending } = useMyRoles();
  const options = (data ?? []).map(r => ({ value: String(r.id), label: r.name }));
  return (
    <Select
      data={options}
      value={value == null ? null : String(value)}
      onChange={s => onChange(s == null ? -1 : Number(s))}
      placeholder={isPending ? 'Loading…' : 'Select a role'}
      searchable
      nothingFoundMessage="No roles available"
      w={260}
    />
  );
}
